export default __webpack_public_path__ + "static/media/defi-saver.de4f3a4b.svg";